var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyOfferBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 245,
    height: 163,
    viewBox: "0 0 245 163",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#161643;}.b,.c,.d{fill:rgba(110,110,134,0.39);}.c{opacity:0.056;}.d,.e{opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19.352 -71)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 245,
    height: 163,
    transform: "translate(19.352 71)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(110.281 69.955)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M62.573,69.273v33.382a4.045,4.045,0,0,1-4.04,4.04H4.04A4.045,4.045,0,0,1,0,102.655V69.273a4.045,4.045,0,0,1,4.04-4.04H5.789v-1.8a2.629,2.629,0,0,1,2.626-2.626h3.876a2.629,2.629,0,0,1,2.626,2.626v1.8h5.6L22.2,60.649A3.451,3.451,0,0,1,25.426,58.4h11.72a3.451,3.451,0,0,1,3.228,2.253l1.682,4.583H58.532A4.045,4.045,0,0,1,62.573,69.273Zm-2.694,33.382V99.2H54.543A1.346,1.346,0,0,1,53.2,97.849V74.078a1.347,1.347,0,0,1,1.347-1.347h5.336V69.273a1.349,1.349,0,0,0-1.347-1.347H4.04a1.349,1.349,0,0,0-1.347,1.347v3.459H8.03a1.347,1.347,0,0,1,1.347,1.347V97.849A1.346,1.346,0,0,1,8.03,99.2H2.694v3.459A1.348,1.348,0,0,0,4.04,104H58.532A1.348,1.348,0,0,0,59.879,102.655Zm0-6.152V75.425H55.89V96.5ZM39.188,65.232l-1.341-3.654a.75.75,0,0,0-.7-.489H25.426a.75.75,0,0,0-.7.489l-1.341,3.654Zm-26.83,0v-1.8a.067.067,0,0,0-.067-.067H8.415a.067.067,0,0,0-.067.067v1.8ZM6.683,96.5V75.425H2.694V96.5Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M79.226,167.646V171.1a1.348,1.348,0,0,1-1.347,1.347H23.387A1.348,1.348,0,0,1,22.04,171.1v-3.459h5.336a1.346,1.346,0,0,0,1.347-1.347V142.528a1.347,1.347,0,0,0-1.347-1.347H22.04v-3.459a1.349,1.349,0,0,1,1.347-1.347H77.879a1.349,1.349,0,0,1,1.347,1.347v3.459H73.889a1.347,1.347,0,0,0-1.347,1.347V166.3a1.346,1.346,0,0,0,1.347,1.347ZM66.7,154.414a16.071,16.071,0,1,0-16.071,16.072A16.089,16.089,0,0,0,66.7,154.414Z",
    transform: "translate(-19.346 -68.45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 3.989,
    height: 21.078,
    transform: "translate(55.89 75.425)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M140.567,152.465A16.071,16.071,0,1,1,124.5,168.537,16.089,16.089,0,0,1,140.567,152.465Zm13.513,16.071a13.513,13.513,0,1,0-13.513,13.513A13.528,13.528,0,0,0,154.08,168.536Z",
    transform: "translate(-109.281 -82.573)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M158.947,173.4a13.513,13.513,0,1,1-13.513,13.513A13.528,13.528,0,0,1,158.947,173.4Zm10.028,13.513a10.028,10.028,0,1,0-10.028,10.028A10.04,10.04,0,0,0,168.975,186.916Z",
    transform: "translate(-127.66 -100.952)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M205.806,80.926l1.341,3.654h-15.8l1.341-3.654a.75.75,0,0,1,.7-.489h11.72A.75.75,0,0,1,205.806,80.926Z",
    transform: "translate(-167.959 -19.347)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M183.971,201.913a10.028,10.028,0,1,1-10.028,10.028A10.04,10.04,0,0,1,183.971,201.913Zm7.6,10.028a7.6,7.6,0,1,0-7.6,7.6A7.613,7.613,0,0,0,191.575,211.941Z",
    transform: "translate(-152.685 -125.977)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M201.384,221.749a7.6,7.6,0,1,1-7.6,7.6A7.613,7.613,0,0,1,201.384,221.749Z",
    transform: "translate(-170.098 -143.389)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(2.694 63.37)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M72.314,99.161v1.8H68.3v-1.8a.067.067,0,0,1,.067-.067h3.876A.067.067,0,0,1,72.314,99.161Z",
    transform: "translate(-62.649 -99.094)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 3.989,
    height: 21.078,
    transform: "translate(0 12.055)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyOfferBackground);
export default __webpack_public_path__ + "static/media/empty-offer-background.b6482369fb5f886c62f1731574ead6ec.svg";
export { ForwardRef as ReactComponent };